<div
  class="notifications-wrapper"
  *ngIf="notificationsEnabled"
  [class.notifications-wrapper-with-btn]="(nonPanicNotifications$ | async)?.length > 4"
>
  <button
    mat-raised-button
    class="notifications-wrapper-close"
    [@onClean]="notificationWrapper"
    *ngIf="(nonPanicNotifications$ | async)?.length > 4 && (shouldShowNonPanicNotifications$ | async)"
    id="btn-closeAllNotifications"
    i18n="@@S_CLOSEALL"
    (click)="cleanAll()"
  >
    Close All
  </button>
  <div
    [@onClean]="notificationWrapper"
    *ngIf="!showPanicAlertsOnly && (shouldShowNonPanicNotifications$ | async)"
    [class.notifications-wrapper__container-with-btn]="(nonPanicNotifications$ | async)?.length > 4"
    class="notifications-wrapper__container notifications-wrapper__container-default"
  >
    <fm-notification
      *ngFor="let notification of nonPanicNotifications$ | async"
      [data]="notification"
      [invokeClose]="notificationsToClose.has(notification.id)"
      (clicked)="onClick($event)"
      (removeNotification)="removeNotification($event)"
      (closeNotification)="closeNotification($event)"
    >
    </fm-notification>
  </div>
  <div class="notifications-wrapper__container" *ngIf="(panicNotifications$ | async)?.length > 0">
    <fm-notification
      *ngFor="let notification of panicNotifications$ | async"
      [data]="notification"
      (clicked)="onClick($event)"
      (removeNotification)="removeNotification($event)"
      (closeNotification)="closeNotification($event)"
    >
    </fm-notification>
  </div>
</div>

<ng-template #notificationDetails>
  <fm-notification-details [details]="notificationDetails$ | async" (modalClosed)="onCloseModal()"></fm-notification-details>
</ng-template>
